import React from 'react'
import { Tabs, TabsContainer } from 'styling/GlobalStyles'

interface SubTab {
  key: string
  label: string
}

interface ISubTabBar {
  tabs: SubTab[]
  activeTab: string
  onTabChange: (key: string) => void
}

export const SubTabBar = ({ tabs, activeTab, onTabChange }: ISubTabBar) => {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <Tabs
          key={tab.key}
          active={activeTab === tab.key}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </Tabs>
      ))}
    </TabsContainer>
  )
}
